export const SET_ERRORS = 'SET_ERRORS'
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const SET_IS_SIDEBAR_OPEN = 'SET_IS_SIDEBAR_OPEN'
export const SET_SHOW_CHAT_WABEE = 'SET_SHOW_CHAT_WABEE'
